import React, { useEffect, useState } from 'react'
import { useLocation, useHistory } from 'react-router-dom'
import styles from './index.module.less'

const tabData = ['密码登录', '短信登录']
const paths = ['/mobile/id', '/mobile/phone']

export default function Index() {
  const history = useHistory()
  const [bar, setBar] = useState(0)
  const { pathname } = useLocation()

  // 点击跳转
  const jump = index => {
    history.push(paths[index])
  }

  useEffect(() => {
    setBar(paths.indexOf(pathname))
  }, [pathname])

  return (
    <div className={styles.tabs}>
      {tabData.map((item, index) => (
        <div
          key={item}
          className={bar === index ? styles.on : ''}
          onClick={() => bar !== index && jump(index)}>
          {item}
        </div>
      ))}
    </div>
  )
}
